export default __webpack_public_path__ + "8e7b4f3ff4abfe09f4505dd8b9d84387.png";